<ng-container *transloco="let t;">
    <form [formGroup]="filterForm" (ngSubmit)="applyFilter()" #form="ngForm">
        <div class="row">
            <div class="col-xl-12 col-md-12 col-12 mb-0">
                <div class="form-group">
                    <input type="number" formControlName='value' [step]="step"
                           class="form-control"/>
                    <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
                        <div *ngIf="filterForm.controls['value'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-xl-12 col-md-12 col-12 mb-0">
                <div class="form-group">
                    <label>{{ t('Advanced filter operator label (Advanced filters) - Operator') }}</label>
                    <app-operator-selector formControlName="operator"
                                           class="form-control"
                                           [items]="availableOperators"></app-operator-selector>
                    <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
                        <div *ngIf="filterForm.controls['operator'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row" *ngIf="filterForm?.value.operator === AdvancedFilterOperatorEnum.between">
            <div class="col-xl-12 col-md-12 col-12 mb-0">
                    <div class="form-group">
                        <input type="number" formControlName='value2' [min]="minimalValue" [max]="maximalValue" [step]="step"
                               class="form-control"/>
                        <div *ngIf="form.submitted && filterForm.invalid" class="invalid-feedback d-block">
                            <div *ngIf="filterForm.controls['value2'].hasError('required')">{{ t('Advanced filter required field validation (Advanced filters) - This field is required') }}</div>
                            <div *ngIf="filterForm.controls['value2'].hasError('min')">
                                {{
                                    t('Advanced filter minimal value validation (Advanced filters) - The minimal allowed value is', {
                                        min: filterForm.controls['value2'].getError('min')?.min
                                    })
                                }}
                            </div>
                            <div *ngIf="filterForm.controls['value2'].hasError('max')">
                                {{
                                    t('Advanced filter maximum value validation (Advanced filters) - The maximum allowed value is', {
                                        max: filterForm.controls['value2'].getError('max')?.max
                                    })
                                }}
                            </div>
                        </div>
                </div>
            </div>
        </div>

        <hr/>
        <button type="submit"
                class="btn btn btn-primary btn-sm w-100">{{ t('Apply filter button name (Advanced filters) - Done') }}
        </button>
    </form>
</ng-container>